import { defineNuxtPlugin } from 'nuxt/app'
import { useAppStore } from '~/stores/app'

export default defineNuxtPlugin(() => {
  const appStore = useAppStore()
  appStore.initPlatform()
})
